<template>
  <div>
    <Multiselect
      class="multiselector-rewards"
      v-model="value"
      mode="tags"
      :close-on-select="false"
      :options="options"
      :searchable="true"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'idCompany', 'checkProducts'],
  emits: ['onChange', 'onValidateProducts'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      if (this.checkProducts === true) this.validateProducts();
      this.$emit('onChange', this.value);
    },
    idCompany() {
      this.getOptions();
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/rewards')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return {
              value: b.id,
              label: `${b.name} (${b.name_product_type})`,
              idProductType: b.id_product_type,
              slug: b.slug
            };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    validateProducts() {
      const rewards = this.options.filter((rw) => Array.from(this.value).includes(rw.value));
      const productTypes = rewards.map((rw) => `${rw.idProductType}-${rw.slug}`);

      this.$emit('onValidateProducts', this.$utils.checkIfDuplicateExists(productTypes));
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style scoped>
.multiselector-rewards {
  border: 1px solid #e2e5e8 !important;
  border-radius: 0.75rem !important;
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>
